import React from 'react';
import { Typography, Tooltip, Space } from 'antd';

export { MongoRef, compassFilter };

const { Text } = Typography;

// Build a Compass-ready query-bar filter for a document's _id. ObjectId hex ids
// get wrapped in ObjectId(...); string ids (e.g. Counter._id) get quoted.
function compassFilter(id) {
    const s = String(id);
    return /^[0-9a-fA-F]{24}$/.test(s) ? `{ _id: ObjectId('${s}') }` : `{ _id: '${s}' }`;
}

// Renders the tail of the _id + a copy button that copies the full Compass filter.
// Tooltip names the collection so you know which one to open in Compass.
function MongoRef({ id, collection }) {
    if (!id) return <Text type="secondary">—</Text>;
    const s = String(id);
    const filter = compassFilter(id);
    return (
        <Space size={4}>
            <Tooltip title={<span>Collection: <b>{collection}</b><br />{filter}</span>}>
                <Text code style={{ fontSize: 11 }}>…{s.slice(-6)}</Text>
            </Tooltip>
            <Text copyable={{ text: filter, tooltips: ['Copy filter Compass', 'Đã copy'] }} />
        </Space>
    );
}
